/**
 * Newsletter → HubSpot.
 *
 * The Shopify newsletter form (email only) submits to Shopify as usual. In
 * parallel we POST the email to the HubSpot Newsletter form via the public
 * Forms API v3 integration endpoint, so the contact also lands in HubSpot and
 * the form's configured "Marketing Information" subscription is applied.
 *
 * Endpoint: https://api.hsforms.com/submissions/v3/integration/submit/{portalId}/{formId}
 * - Public endpoint (keyed on portalId+formId); no auth/secret needed client-side.
 * - We do NOT preventDefault — Shopify still gets the submission. The HubSpot
 *   call uses keepalive:true so it survives the page navigation.
 * - Fire-and-forget: any HubSpot error (e.g. reCAPTCHA enabled on the form) is
 *   swallowed so the customer's Shopify subscribe flow is never affected. Once
 *   reCAPTCHA is disabled on the form, submissions will land in HubSpot.
 *
 * Config comes from data attributes on the [data-hs-newsletter] wrapper:
 *   data-hs-portal-id, data-hs-form-id
 */
(function () {
  'use strict';

  // Reads a cookie by name — used for HubSpot's tracking cookie `hubspotutk`.
  function getCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : '';
  }

  function bind(wrap) {
    var portal = wrap.getAttribute('data-hs-portal-id');
    var formId = wrap.getAttribute('data-hs-form-id');
    var form = wrap.querySelector('form');
    if (!form || !portal || !formId || form.__hsNewsletterBound) return;
    form.__hsNewsletterBound = true;

    form.addEventListener('submit', function () {
      var emailEl = form.querySelector('[name="contact[email]"]');
      var email = emailEl && emailEl.value ? emailEl.value.trim() : '';
      if (!email) return; // let Shopify handle empty/invalid; don't send junk to HubSpot

      var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + formId;
      var context = { pageUri: window.location.href, pageName: document.title };
      // Attribute the signup to the visitor's HubSpot session/source when the tracking cookie is present.
      var hutk = getCookie('hubspotutk');
      if (hutk) context.hutk = hutk;
      try {
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({
            fields: [{ objectTypeId: '0-1', name: 'email', value: email }],
            context: context,
          }),
        }).catch(function () {});
      } catch (e) {}
      // No preventDefault — the Shopify subscribe submission proceeds normally.
    });
  }

  function init() {
    document.querySelectorAll('[data-hs-newsletter]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
